import { registerEventHandlers } from "/events";

import "/modules/base";
import "/modules/legacy";
import "/modules/leaving-popup";

import { setWdyhauTrafficCookie } from "/modules/wdyhau-survey";
import { eventHandlers as abTestEventHandlers } from "/modules/abtest-toggle";

import "/features/trial-duration-explanation/init";
import "/features/category-explorer/init";

import "/styles/partner-page";

registerEventHandlers([
  abTestEventHandlers
]);

setWdyhauTrafficCookie();
